import React, { Component } from "react";
import PropTypes from "prop-types";
import { Portal } from "react-portal";
import "./BuyButton.scss";
import BasketPopup from "../Popup/Popup";
import { getLoaderColor } from "../../common/utils";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

const BuyButton = ({ store, wpObject }) => {
  const displayToast = error => {
    toast.error(error);
    store.togglePopup("popupBasket", false);
  };
  return (
    <>
      <button
        className={`elementor-size-xl elementor-animation-shrink elementor-button ${wpObject.color_type}`}
        onClick={() => store.togglePopup("popupBasket", true)}
      >
        {wpObject.text_button}
      </button>
      {store.popupBasket ? (
        <BasketPopup
          productId={wpObject.id}
          loaderColor={getLoaderColor(wpObject.color_type)}
          productType={wpObject.type}
          canBuyMany={wpObject.can_buy_many}
          toastSomething={displayToast}
          store={store}
        />
      ) : null}
      <Portal>
        <ToastContainer />
      </Portal>
    </>
  );
};

export default BuyButton;

BuyButton.propTypes = {
  wpObject: PropTypes.object
};
